import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  Button,
} from '@scio3/ui';
import { useConfirmStore } from '@/stores/confirm-store';

const DESTRUCTIVE_CLASS = 'bg-destructive text-destructive-foreground hover:bg-destructive/90';

/**
 * Global confirm dialog — render once in App.tsx.
 * Triggered imperatively via `useConfirm()` hook.
 */
export function ConfirmDialog() {
  const { isOpen, options, close } = useConfirmStore();

  if (!options) return null;

  const showConfirm = options.confirm !== false;
  const showCancel = options.cancel !== false;
  const confirmLabel = (options.confirm && options.confirm.label) || 'OK';
  const confirmVariant = options.confirm && options.confirm.variant;
  const cancelLabel = (options.cancel && options.cancel.label) || 'Cancel';

  return (
    <AlertDialog open={isOpen} onOpenChange={(open) => !open && close(false)}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{options.title}</AlertDialogTitle>
          {options.html ? (
            <AlertDialogDescription asChild>
              {/*
                Safe: html option is only used with controlled i18n translation strings,
                never with user-generated content.
              */}
              <div dangerouslySetInnerHTML={{ __html: options.description }} />
            </AlertDialogDescription>
          ) : (
            <AlertDialogDescription>{options.description}</AlertDialogDescription>
          )}
        </AlertDialogHeader>
        <AlertDialogFooter>
          {showCancel && (
            <AlertDialogCancel onClick={() => close(false)}>{cancelLabel}</AlertDialogCancel>
          )}
          {options.alt && (
            <Button
              variant={options.alt.variant === 'destructive' ? 'destructive' : 'outline'}
              onClick={() => close('alt')}
            >
              {options.alt.label}
            </Button>
          )}
          {showConfirm && (
            <AlertDialogAction
              onClick={() => close('confirm')}
              className={confirmVariant === 'destructive' ? DESTRUCTIVE_CLASS : undefined}
            >
              {confirmLabel}
            </AlertDialogAction>
          )}
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
